export const FETCH_EDITABLE_USER_INFO = 'FETCH_EDITABLE_USER_INFO'
export const FETCH_EDITABLE_USER_INFO_SUCCESS = 'FETCH_EDITABLE_USER_INFO_SUCCESS'
export const FETCH_EDITABLE_USER_ERROR = 'FETCH_EDITABLE_USER_ERROR'
export const SAVE_EDITABLE_USER = 'SAVE_EDITABLE_USER'
export const CLEAR_EDITABLE_USER = 'CLEAR_EDITABLE_USER'
